var __WEBPACK_NAMESPACE_OBJECT__ = require("roboflex-thalamus-request-handler/dist");